var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterTopRightDarkMode(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212134",
    d: "M99.9 0h199.8v199.8H99.9zM0 0h99.9v99.9H0zM199.801 199.8h99.9v99.9h-99.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.699 0v50h50v50h50V0h-100z",
    fill: "#8C4BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M249.701 50.001h-49.81v50.098h49.81V50.001z",
    fill: "#8C4BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.701 100.099h-49.81v50.097h49.81v-50.097zM299.7 150.196h-49.8v50.098h49.8v-50.098zM99.89 100.099h-49.8v50.097h49.8v-50.097zM149.701 0h-49.81v50.098h49.81V0z",
    fill: "#32324D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M199.699 50h-50l50-50v50zM249.4 150v-50h50l-50 50z",
    fill: "#8C4BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTopRightDarkMode);
export default "/_next/static/images/f6b0ca0695c883f9a380a81f786df648.svg";
export { ForwardRef as ReactComponent };